import type { RExternalOrgApp } from 'v2/types/api/settings'
import { IntegrationState } from './constants'

export const RECONNECT_REQUIRED_STATE = 'RECONNECT_REQUIRED'

export const getIntegrationStatusOptions = (aciEnabled = false) => [
  { label: 'Active', value: IntegrationState.ACTIVE },
  { label: 'Disabled', value: IntegrationState.DISABLED },
  { label: 'Expired', value: IntegrationState.EXPIRED },
  ...(aciEnabled ? [{ label: 'Reconnect required', value: RECONNECT_REQUIRED_STATE }] : []),
]

export const requiresAciReconnect = (
  app: Pick<RExternalOrgApp, 'integration_source'>,
  aciEnabled = false,
) => aciEnabled && app.integration_source === 'nango'

export const effectiveIntegrationState = (
  app: Pick<RExternalOrgApp, 'integration_source' | 'state'>,
  aciEnabled = false,
) => (requiresAciReconnect(app, aciEnabled) ? RECONNECT_REQUIRED_STATE : app.state?.toUpperCase())

export const isAciExecutionTarget = (app: RExternalOrgApp, aciEnabled = false) =>
  aciEnabled
    ? !requiresAciReconnect(app, aciEnabled) && app.state?.toUpperCase() === IntegrationState.ACTIVE
    : app.state?.toUpperCase() !== IntegrationState.EXPIRED
